<template>
  <skeleton v-if="loading"></skeleton>
  <div v-else-if="paymentMethods.length" class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
    <div
        class="py-[18px] px-4 rounded-md bg-slate-100 dark:bg-slate-900"
        v-for="(item, i) in paymentMethods"
        :key="i"
    >
      <div class="flex items-start space-x-5 rtl:space-x-reverse">
        <div class="flex-none">
          <img width="32" :src="image(item.type)" alt="">
        </div>
        <div class="flex-1 overflow-hidden break-words space-y-3">
          <div
              class="text-slate-600 dark:text-slate-300 text-md mb-2 font-bold"
          >
            {{ item.name }}
          </div>
          <div class="text-slate-900 dark:text-white text-sm font-medium w-full">
            <p class="text-blue-500 dark:text-success-400">
              {{ item.type === 'Crypto' ? $t('message.network.label') + ': ' : $t('message.iban.label') + ': ' }}</p>
            {{ item.type === 'Crypto' ? item.crypto.network : item.rial.iban }}
          </div>
          <div class="text-slate-900 dark:text-white text-sm font-medium w-full">
            <p class="text-violet-600 dark:text-sky-500">{{
                item.type === 'Crypto' ? $t('message.address.label') + ': ' : $t('message.cardNumber.label') + ': '
              }}</p>
            {{ item.type === 'Crypto' ? item.crypto.address : item.rial.cardNumber }}
          </div>
        </div>
        <div>
          <Icon icon="basil:edit-outline" height="20"
                class="cursor-pointer mb-2 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-300"
                @click="editPaymentData(item)"/>
          <Icon icon="fluent:delete-24-regular" height="20"
                class="cursor-pointer dark:text-slate-300 hover:text-red-700 dark:hover:text-red-400"
                @click="removePaymentData(item)"/>
        </div>
      </div>
    </div>
  </div>
  <div v-else
       class="flex justify-center flex-wrap items-center flex-col text-center gap-10"
  >
    <img src="@/assets/images/all-img/no-data1.png" alt=""/>
<!--    <h4 class="text-3xl font-medium text-slate-900 dark:text-white mb-2">
      NO DATA
    </h4>-->
    <p class="font-normal text-base text-slate-500 dark:text-slate-300">
      There are no payment methods yet
    </p>
  </div>
</template>
<script>
import {usePaymentMethodsStore} from "@/stores/payment.js";
import {computed, onMounted, ref, watch} from "vue";
import {Icon} from "@iconify/vue";
import skeleton from "@/components/Skeleton/PaymentMethods.vue"
import rial from "@/assets/images/icon/card.png"
import crypto from "@/assets/images/icon/tether2.png"

export default {
  components: {
    Icon,
    skeleton
  },
  props: {
    changeInMethods: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, {emit}) {
    const paymentMethods = ref([])
    const paymentMethodsStore = usePaymentMethodsStore();
    const loading = ref(false);

    function image(type) {
      if (type === 'Rial') {
        return rial
      } else if (type === 'Crypto') {
        return crypto
      }
    }

    async function getPaymentMethods() {
      loading.value = true;
      await paymentMethodsStore.action_getPaymentMethods()
      paymentMethods.value = paymentMethodsStore.getPaymentMethods;
      loading.value = false;
    }

    async function editPaymentData(item) {
      emit('editModal', item)
    }

    async function removePaymentData(item) {
      emit('removeModal', item)
    }

    watch(
        () => props.changeInMethods,
        (newValue) => {
          console.log(newValue)
          if (newValue) {
            getPaymentMethods()
          }
        }
    );

    onMounted(() => {
      getPaymentMethods();
    })

    return {
      paymentMethods,
      loading,
      editPaymentData,
      removePaymentData,
      image
    }
  }
};
</script>
<style lang=""></style>
